import { HTMLBanner } from "../../components/banner-html";

const test = ({ layout }: { layout: string }): boolean =>
  layout === "HTML Banner";

const create = (props): JSX.Element => {
  return <HTMLBanner {...props} />;
};

export default { test, create };
